<template>
  <div class="password">
    <div class="password-title">{{ t('changePassword.title') }}</div>
    <div class="passwprd_content">
      <el-form label-width="auto" :model="formLabelAlign" :rules="rules" style="width: 600px">
        <el-form-item :label="t('changePassword.oldPwd')" :label-position="itemLabelPosition" prop="name">
          <el-input
            v-model="formLabelAlign.name"
            :type="showOldPassword ? 'text' : 'password'"
            :placeholder="t('changePassword.oldPwdPh')"
          >
            <template #suffix>
              <el-icon class="password-toggle" @click="toggleOldPassword">
                <component :is="showOldPassword ? 'View' : 'Hide'" />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item :label="t('changePassword.newPwd')" :label-position="itemLabelPosition" prop="region">
          <el-input
            v-model="formLabelAlign.region"
            :type="showNewPassword ? 'text' : 'password'"
            :placeholder="t('changePassword.newPwdPh')"
          >
            <template #suffix>
              <el-icon class="password-toggle" @click="toggleNewPassword">
                <component :is="showNewPassword ? 'View' : 'Hide'" />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item :label="t('changePassword.confirmPwd')" :label-position="itemLabelPosition" prop="repeatPwd">
          <el-input
            v-model="formLabelAlign.repeatPwd"
            :type="showConfirmPassword ? 'text' : 'password'"
            :placeholder="t('changePassword.confirmPwdPh')"
            @blur="checkSame()"
          >
            <template #suffix>
              <el-icon class="password-toggle" @click="toggleConfirmPassword">
                <component :is="showConfirmPassword ? 'View' : 'Hide'" />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn_box">
      <el-button type="primary" @click="submit()">{{ t('changePassword.submit') }}</el-button>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from "vue";
import { ElMessage } from "element-plus";
import { useUserStore } from '@/stores/modules/user.js'
import { changePwdApi } from "@/api/login.js"
import { View, Hide } from '@element-plus/icons-vue'
import { usePageI18n } from '@/composables/usePageI18n.js'
import { t } from '@/locale/index.js'

const itemLabelPosition = ref("top");
const userStore = useUserStore()

const showOldPassword = ref(false)
const showNewPassword = ref(false)
const showConfirmPassword = ref(false)

const formLabelAlign = reactive({
  name: "",
  region: "",
  repeatPwd: "",
});

const rules = reactive({
  name: [{ required: true, message: t('changePassword.needOld'), trigger: "blur" }],
  region: [{ required: true, message: t('changePassword.needNew'), trigger: "blur" }],
  repeatPwd: [{ required: true, message: t('changePassword.needConfirm'), trigger: "blur" }],
})

const applyLabels = () => {
  rules.name[0].message = t('changePassword.needOld')
  rules.region[0].message = t('changePassword.needNew')
  rules.repeatPwd[0].message = t('changePassword.needConfirm')
}
usePageI18n(applyLabels)
applyLabels()

const toggleOldPassword = () => { showOldPassword.value = !showOldPassword.value }
const toggleNewPassword = () => { showNewPassword.value = !showNewPassword.value }
const toggleConfirmPassword = () => { showConfirmPassword.value = !showConfirmPassword.value }

const checkSame = () => {
  if (formLabelAlign.region !== formLabelAlign.repeatPwd) {
    ElMessage.error(t('changePassword.pwdMismatch'))
  }
}

const submit = () => {
  const { user } = JSON.parse(localStorage.getItem('user'))
  const params = JSON.stringify({
    id: user.users.id,
    username: user.users.username,
    password: user.users.password,
    newPassword: formLabelAlign.region,
  })
  changePwdApi(params).then((res) => {
    if (res.code === 200) {
      ElMessage.success(t('changePassword.success'))
    } else {
      ElMessage.error(res?.msg || t('changePassword.failed'))
    }
  })
}
</script>

<style lang="less" scoped>
.password {
  background-color: #fff;
  flex: 1;
  margin-right: 20px;
  height: 100%;
  &-title {
    font-weight: bold;
    padding: 10px 25px;
  }
}

.passwprd_content {
  width: 100%;
  height: calc(100% - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn_box {
  display: flex;
  justify-content: center;
}

.password-toggle {
  cursor: pointer;
  color: #909399;
  font-size: 16px;

  &:hover {
    color: #409eff;
  }
}
</style>
